<template>
  <div>
    <a-button v-if="selectedTeacher" type="primary" @click="showAccessDrawer"
      ><a-icon type="setting" />{{ $t("menu.accessTeacher") }}</a-button
    >
    <!-- START ACCESS SCHED DRAWER -->
    <a-drawer
      v-if="visibleAccessDrawer"
      :title="$t('enseignant.addAccess')"
      width="50%"
      :visible="visibleAccessDrawer"
      @close="() => (visibleAccessDrawer = false)"
    >
      <a-form :form="form" layout="vertical" hide-required-mark>
        <a-row :gutter="24" class="mb-4">
          <a-col
            :span="24"
            class="d-flex align-items-center justify-content-between"
          >
            <div class="d-flex align-items-center">
              <a-card :bordered="true" class="border border-secondary">
                <div class="d-flex flex-column align-items-center">
                  <span class="h5 font-weight-bold">{{
                    selectedTeacherName
                  }}</span>
                  <span class="fs-4">{{
                    $t("emploi.trimestre") + " " + selectedTrimester
                  }}</span>
                </div>
              </a-card>
            </div>
            <a-form-item
              :label="$t('emploi.classe')"
              class="mb-0 flex-grow-1 ml-4"
              :colon="false"
            >
              <a-select
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
                :loading="loading"
                @change="
                  (val) => {
                    handleClassChange(val);
                  }
                "
                v-decorator="[
                  'classeRoom',
                  {
                    rules: [
                      {
                        required: true,
                        message: $t('emploi.choisirClasse'),
                      },
                    ],
                  },
                ]"
                :placeholder="$t('emploi.choisirClasse')"
                class="w-100"
              >
                <a-select-option
                  v-for="classe in filtredClasses"
                  :key="classe._id"
                  :value="classe._id"
                >
                  {{ classe.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16" v-if="loadingSubjects">
          <a-col :span="24">
            <div>
              <a-spin :tip="$t('all.loadingText')" :spinning="!!selectedClassroom">
                <div class="spin-content">
                  <a-alert
                    :message="$t('enseignant.selectClassMessage')"
                    type="info"
                    show-icon
                  />
                </div>
              </a-spin>
            </div>
          </a-col>
        </a-row>
        <a-row :gutter="16" v-else>
          <a-col :span="12">
            <a-form-item :label="$t('emploi.matiere')">
              <!-- College: use checkboxes so selection is reliably stored (Tree @check doesn't fire for child nodes when parent is checkable=false) -->
              <div v-if="isCollegeSubjectSelection" class="subject-checkbox-list">
                <div
                  v-for="m in subjectTeeData"
                  :key="m.key || m._id"
                  class="mb-2"
                >
                  <div
                    v-if="m.name && String(m.name).trim()"
                    class="text-muted small mb-1"
                  >
                    {{ m.name }}
                    <a-tag v-if="getModuleTypeLabel(m.type) !== '--'" color="blue" size="small">
                      {{ getModuleTypeLabel(m.type) }}
                    </a-tag>
                  </div>
                  <div class="d-flex flex-column">
                    <a-checkbox
                      v-for="s in (m.subjects || [])"
                      :key="String(s._id)"
                      :checked="isSubjectChecked(s._id)"
                      @change="(e) => toggleSubject(s._id, e.target.checked)"
                      class="mb-1 ml-3"
                    >
                      {{ s.name }}
                    </a-checkbox>
                  </div>
                </div>
              </div>
              <!-- Primary: use tree -->
              <a-tree
                v-else
                ref="subjectsTree"
                v-model="checkedSubKeys"
                checkable
                :selected-keys="selectedSubKeys"
                default-expand-all
                @check="onCheck"
              >
                <a-tree-node
                  :key="m.key"
                  v-for="m in subjectTeeData"
                  :checkable="false"
                >
                  <template slot="title">
                    <span
                      >{{ m.name }}
                      <a-tag color="blue" v-show="getModuleTypeLabel(m.type)!='--'">{{
                        getModuleTypeLabel(m.type)
                      }}</a-tag>
                    </span>
                  </template>
                  <a-tree-node
                    v-for="s in m.subjects"
                    :key="String(s._id)"
                    :title="s.name"
                  />
                </a-tree-node>
              </a-tree>
            </a-form-item>
          </a-col>
          <a-col :span="1">
            <a-divider type="vertical" />
          </a-col>
          <a-col :span="11" v-if="selectedLevel ">
            <a-form-item :label="$t('scolarite.appreciation')">
              <a-tree
                ref="appreciationTree"
                v-model="checkedAppKeys"
                checkable
                :selected-keys="selectedAppKeys"
                default-expand-all
                @check="onAppCheck"
              >
                <a-tree-node
                  :key="m.key"
                  v-for="m in appTreeData"
                  :checkable="isModuleCheckable(m)"
                  :disabled="allNodeIsDisabled(m)"
                >
                  <template slot="title">
                    <span
                      >{{ m.name }}
                      <a-tag color="blue">{{
                        getModuleTypeLabel(m.type)
                      }}</a-tag>
                      <a-popover
                        v-if="
                          isModuleCheckable(m) &&
                          conflictModuleIds[m._id] &&
                          checkedAppKeys.includes(m.key)
                        "
                        :title="$t('error.alreadyAssigned')"
                      >
                        <template slot="content">
                          <p
                            v-for="(teacher, index) in conflictModuleIds[m._id]"
                            :key="index"
                          >
                            <strong>{{ teacher }}</strong>
                          </p>

                          <a-button
                            type="danger"
                            size="small"
                            class="ml-2"
                            @click="revokeAccess(m._id)"
                          >
                            <a-icon type="delete" /> {{ $t("action.revoke") }}
                          </a-button>
                        </template>
                        <a-icon
                          type="warning"
                          theme="filled"
                          :style="{
                            color: 'orange',
                          }"
                        ></a-icon>
                      </a-popover>
                      <a-popover
                        v-else-if="
                          isModuleCheckable(m) && conflictModuleIds[m._id]
                        "
                        :title="$t('error.alreadyAssigned')"
                      >
                        <template slot="content">
                          <p
                            v-for="(teacher, index) in conflictModuleIds[m._id]"
                            :key="index"
                          >
                            <strong>{{ teacher }}</strong>
                          </p>

                          <a-button
                            type="danger"
                            size="small"
                            class="ml-2"
                            @click="revokeAccess(m._id)"
                          >
                            <a-icon type="delete" /> {{ $t("action.revoke") }}
                          </a-button>
                        </template>
                        <a-icon
                          type="info-circle"
                          theme="filled"
                          :style="{
                            color: '#9ed7fd',
                          }"
                        ></a-icon>
                      </a-popover>
                    </span>
                  </template>
                  <!-- College: show subjects as checkable appreciation options -->
                  <a-tree-node
                    v-for="s in (m.type === 'college' && m.subjects ? m.subjects : [])"
                    :key="'app-subj-' + s._id"
                    :disabled="!!conflictSubjectIds[s._id]"
                  >
                    <template slot="title">
                      <span>
                        {{ s.name }}
                        <a-popover
                          v-if="
                            conflictSubjectIds[s._id] &&
                            checkedAppKeys.includes('app-subj-' + s._id)
                          "
                          :title="$t('error.alreadyAssigned')"
                        >
                          <template slot="content">
                            <p
                              v-for="(teacher, index) in conflictSubjectIds[s._id]"
                              :key="index"
                            >
                              <strong>{{ teacher }}</strong>
                            </p>
                            <a-button
                              type="danger"
                              size="small"
                              class="ml-2"
                              @click="revokeSubjectAccess(s._id)"
                            >
                              <a-icon type="delete" /> {{ $t("action.revoke") }}
                            </a-button>
                          </template>
                          <a-icon
                            type="warning"
                            theme="filled"
                            :style="{ color: 'orange' }"
                          ></a-icon>
                        </a-popover>
                        <a-popover
                          v-else-if="conflictSubjectIds[s._id]"
                          :title="$t('error.alreadyAssigned')"
                        >
                          <template slot="content">
                            <p
                              v-for="(teacher, index) in conflictSubjectIds[s._id]"
                              :key="index"
                            >
                              <strong>{{ teacher }}</strong>
                            </p>
                            <a-button
                              type="danger"
                              size="small"
                              class="ml-2"
                              @click="revokeSubjectAccess(s._id)"
                            >
                              <a-icon type="delete" /> {{ $t("action.revoke") }}
                            </a-button>
                          </template>
                          <a-icon
                            type="info-circle"
                            theme="filled"
                            :style="{ color: '#9ed7fd' }"
                          ></a-icon>
                        </a-popover>
                      </span>
                    </template>
                  </a-tree-node>
                  <!-- Primary: show sous-modules -->
                  <a-tree-node
                    :key="s._id"
                    v-for="s in (m.type !== 'college' && m.sousModules ? m.sousModules : [])"
                    :disabled="!!conflictSubModuleIds[s._id]"
                  >
                    <template slot="title">
                      <span>
                        {{ s.name }}
                        <a-popover
                          v-if="
                            conflictSubModuleIds[s._id] &&
                            checkedAppKeys.includes(s._id)
                          "
                          :title="$t('error.alreadyAssigned')"
                        >
                          <template slot="content">
                            <p
                              v-for="(teacher, index) in conflictSubModuleIds[
                                s._id
                              ]"
                              :key="index"
                            >
                              <strong>{{ teacher }}</strong>
                            </p>

                            <a-button
                              type="danger"
                              size="small"
                              class="ml-2"
                              @click="revokeAccess(null, true, s._id)"
                            >
                              <a-icon type="delete" />
                              {{ $t("action.revoke") }}
                            </a-button>
                          </template>
                          <a-icon
                            type="warning"
                            theme="filled"
                            :style="{
                              color: 'orange',
                            }"
                          ></a-icon>
                        </a-popover>
                        <a-popover
                          v-else-if="conflictSubModuleIds[s._id]"
                          :title="$t('error.alreadyAssigned')"
                        >
                          <template slot="content">
                            <p
                              v-for="(teacher, index) in conflictSubModuleIds[
                                s._id
                              ]"
                              :key="index"
                            >
                              <strong>{{ teacher }}</strong>
                            </p>

                            <a-button
                              type="danger"
                              size="small"
                              class="ml-2"
                              @click="revokeAccess(null, true, s._id)"
                            >
                              <a-icon type="delete" />
                              {{ $t("action.revoke") }}
                            </a-button>
                          </template>
                          <a-icon
                            type="info-circle"
                            theme="filled"
                            :style="{
                              color: '#9ed7fd',
                            }"
                          ></a-icon>
                        </a-popover>
                      </span>
                    </template>
                  </a-tree-node>
                </a-tree-node>
              </a-tree>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24"> </a-col>
        </a-row>
      </a-form>

      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1,
        }"
      >
        <a-button
          :style="{ marginRight: '8px' }"
          @click="() => (visibleAccessDrawer = false)"
        >
          {{ $t("action.annuler") }}
        </a-button>
        <a-button
          type="primary"
          @click="handleSubmit"
          :loading="loadingAddBtn"
          :disabled="loadingAddBtn"
        >
          {{ $t("action.modifier") }}
        </a-button>
      </div>
    </a-drawer>
  </div>
</template>
<script>
import apiClient from "@/services/axios";
export default {
  props: {
    selectedTeacher: {
      required: true,
    },
    selectedTeacherName: {
      required: true,
    },
    selectedTrimester: {
      required: true,
    },
    listSubjects: {
      required: true,
    },
  },
  data() {
    return {
      visibleAccessDrawer: false,
      loadingAddBtn: false,
      form: this.$form.createForm(this),
      filtredClasses: [],
      loadingSubjects: true,
      data: [],
      loading: false,
      selectedClassroom: null,
      checkedSubKeys: [],
      selectedSubKeys: [],
      subjectTeeData: [],
      appTreeData: [],
      checkedAppKeys: [],
      selectedAppKeys: [],
      conflictModuleIds: [],
      conflictSubModuleIds: [],
      conflictSubjectIds: {},
      selectedLevel: null,
      // Backup of checked keys from last @check event (in case v-model doesn't sync)
      lastCheckedSubKeys: [],
      lastCheckedAppKeys: [],
    };
  },
  computed: {
    isCollegeSubjectSelection() {
      return this.selectedLevel != null && Number(this.selectedLevel) >= 7;
    },
  },
  mounted() {},
  methods: {
    getModuleTypeLabel(type) {
      switch (type) {
        case "MP":
          return this.$t("moduleType.pedagogicalModule");
        case "MT":
          return this.$t("moduleType.pilotModule");
        case "MS":
          return this.$t("moduleType.specificModule");
        case "college":
          return this.$t("menu.bulletinCollege");
        default:
          return "--";
      }
    },

    async handleClassChange(value) {
      try {
        this.loadingSubjects = true;
        this.selectedClassroom = value;
        this.checkedSubKeys = [];
        this.checkedAppKeys = [];
        this.lastCheckedSubKeys = [];
        this.lastCheckedAppKeys = [];
        this.conflictSubjectIds = {};
        // First API call to get subjects and appAccessFlat
        let query = {
          query: {
            teacher: this.selectedTeacher,
            trimester: this.selectedTrimester,
            classroom: value,
          },
        };
        const classLevel = this.filtredClasses.find(
          (c) => c._id == value
        ).level;
        this.selectedLevel = classLevel;
        // Use Promise.all to execute both API calls concurrently
        const [allSubjectsResponse, accessTreeResponse] = await Promise.all([
          apiClient.post("/teacherAccess/all", query),
          apiClient.get(
            `/teacherAccess/accesstree/${this.selectedTrimester}/${this.selectedLevel}`
          ),
        ]);

        // Process the first API response
        if (allSubjectsResponse.data[0]) {
          if (allSubjectsResponse.data[0].subjects) {
            this.checkedSubKeys = allSubjectsResponse.data[0].subjects.map(
              (subject) => subject._id
            );
            this.lastCheckedSubKeys = this.checkedSubKeys.slice();
          }
          if (allSubjectsResponse.data[0].appAccessFlat) {
            this.checkedAppKeys = allSubjectsResponse.data[0].appAccessFlat;
            this.lastCheckedAppKeys = this.checkedAppKeys.slice();
          }

          if (allSubjectsResponse.data[0].conflicts) {
            let moduleMap = {};
            let subModuleMap = {};

            // Handle the new structure where conflicts are organized by teacher
            allSubjectsResponse.data[0].conflicts.forEach((teacherConflict) => {
              // Each teacherConflict now has teacherId, teacherName, and modules array
              const teacherName = teacherConflict.teacherName;

              // Process each module assigned to this teacher
              teacherConflict.modules.forEach((moduleData) => {
                const modId = moduleData.moduleId;

                // Initialize the module entry if it doesn't exist
                moduleMap[modId] = moduleMap[modId] || [];

                // Add this teacher to the module's conflict list
                if (!moduleMap[modId].includes(teacherName)) {
                  moduleMap[modId].push(teacherName);
                }

                // Process each submodule assigned to this teacher for this module
                if (
                  moduleData.sousModules &&
                  moduleData.sousModules.length > 0
                ) {
                  moduleData.sousModules.forEach((smId) => {
                    // Initialize the submodule entry if it doesn't exist
                    subModuleMap[smId] = subModuleMap[smId] || [];

                    // Add this teacher to the submodule's conflict list
                    if (!subModuleMap[smId].includes(teacherName)) {
                      subModuleMap[smId].push(teacherName);
                    }
                  });
                }
              });
            });

            this.conflictModuleIds = moduleMap;
            this.conflictSubModuleIds = subModuleMap;
          }

          if (allSubjectsResponse.data[0].subjectConflicts) {
            this.conflictSubjectIds = allSubjectsResponse.data[0].subjectConflicts;
          }
        }

        // Process the second API response
        if (accessTreeResponse.data && accessTreeResponse.data.length > 0) {
          this.subjectTeeData = accessTreeResponse.data;
          this.appTreeData = accessTreeResponse.data.filter(
            (m) => m.type != "other"
          );
        } else {
          this.subjectTeeData = [];
          this.appTreeData = [];
        }
      } catch (error) {
        console.error("Error while loading data:", error);
      } finally {
        // End the loading state
        this.loadingSubjects = false;
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    async showAccessDrawer() {
      if (!this.selectedTeacher) {
        this.$message.error(this.$t("emploi.choisirEnseignant"));
        return;
      }
      this.selectedClassroom = null;
      this.loading = true;
      this.loadingSubjects = true;
      this.visibleAccessDrawer = true;
      apiClient
        .get(`/teachers/classroomAffectations/${this.selectedTeacher}`)
        .then((res) => {
          this.filtredClasses = res.data;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSubmit(e) {

      e.preventDefault();
      let tmpAppAccess = [];
      // Read checked keys from tree refs if available (ant-design-vue Tree can miss syncing v-model)
      let subKeysFromTree = this.$refs.subjectsTree && this.$refs.subjectsTree.checkedKeys;
      if (subKeysFromTree && !Array.isArray(subKeysFromTree) && subKeysFromTree.checked) {
        subKeysFromTree = subKeysFromTree.checked;
      }
      if (this.$refs.subjectsTree && typeof this.$refs.subjectsTree.getCheckedKeys === "function") {
        const keys = this.$refs.subjectsTree.getCheckedKeys();
        if (Array.isArray(keys)) subKeysFromTree = keys;
      }
      let appKeysFromTree = this.$refs.appreciationTree && this.$refs.appreciationTree.checkedKeys;
      if (appKeysFromTree && !Array.isArray(appKeysFromTree) && appKeysFromTree.checked) {
        appKeysFromTree = appKeysFromTree.checked;
      }
      if (this.$refs.appreciationTree && typeof this.$refs.appreciationTree.getCheckedKeys === "function") {
        const keys = this.$refs.appreciationTree.getCheckedKeys();
        if (Array.isArray(keys)) appKeysFromTree = keys;
      }
      const checkedSubArr = Array.isArray(subKeysFromTree)
        ? subKeysFromTree
        : Array.isArray(this.lastCheckedSubKeys)
          ? this.lastCheckedSubKeys
          : Array.isArray(this.checkedSubKeys)
            ? this.checkedSubKeys
            : [];
      const checkedAppArr = Array.isArray(appKeysFromTree)
        ? appKeysFromTree
        : Array.isArray(this.lastCheckedAppKeys)
          ? this.lastCheckedAppKeys
          : Array.isArray(this.checkedAppKeys)
            ? this.checkedAppKeys
            : [];
      //make appration access compatible to the modal from tree componenet
      let chekedModules = checkedAppArr.filter((key) => key && String(key)[0] === "M");

      this.subjectTeeData.forEach((module) => {
        try {
          const sousModulesIds = module.sousModules.map((sm) => sm._id);
          const moduleChecked = chekedModules.includes(module.key);
          const sousModuleChecked = sousModulesIds.some((id) =>
            checkedAppArr.includes(id)
          );

          if (moduleChecked || sousModuleChecked) {
            let sousModuleIncluded = sousModulesIds.filter((id) =>
              checkedAppArr.includes(id)
            );
            const unitAppAccess = {
              module: module._id,
              haveSubMod: sousModulesIds.length > 0,
              canAppModule:
                sousModuleIncluded.length == module.sousModules.length,
              sousModules: sousModuleIncluded,
            };

            tmpAppAccess.push(unitAppAccess);
          }
        } catch (error) {
          console.error(error);
        }
      });
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loadingAddBtn = true;
          values.teacher = this.selectedTeacher;
          values.trimester = this.selectedTrimester;
          // Build subjects: for college (checkbox UI) use checkedSubKeys directly; for primary use tree data
          let subjectIdsFromLeftTree = [];
          if (this.isCollegeSubjectSelection) {
            subjectIdsFromLeftTree = [...this.checkedSubKeys].map((k) => String(k));
          } else {
            this.subjectTeeData.forEach((m) => {
              const parentKey = m.key || m._id;
              const parentChecked = parentKey && checkedSubArr.some((k) => String(k) === String(parentKey));
              (m.subjects || []).forEach((s) => {
                const id = s._id != null ? String(s._id) : s;
                const idChecked =
                  checkedSubArr.includes(id) ||
                  checkedSubArr.includes(s._id) ||
                  checkedSubArr.some((k) => String(k) === String(s._id));
                if (parentChecked || idChecked) {
                  subjectIdsFromLeftTree.push(String(id));
                }
              });
            });
          }
          values.subjects =
            subjectIdsFromLeftTree.length > 0
              ? [...new Set(subjectIdsFromLeftTree)]
              : checkedSubArr.filter(
                  (id) =>
                    id != null &&
                    typeof id === "string" &&
                    !id.startsWith("M") &&
                    !id.startsWith("app-subj-") &&
                    id !== "college" &&
                    id !== "Mother"
                );
          values.appAccess = tmpAppAccess;
          values.appAccessSubjects = checkedAppArr
            .filter((k) => k && String(k).startsWith("app-subj-"))
            .map((k) => String(k).replace("app-subj-", ""));
          apiClient
            .put(`/teacherAccess`, values)
            .then((res) => {
              if (res.data.revokedFrom && res.data.revokedFrom.length > 0) {
                this.showRevocationNotification(res.data.revokedFrom);
              } else {
                this.$message.success(this.$t("enseignant.accessLevelAddedSuccessfully"));
              }
              this.$emit("reload");
              //this.visibleAccessDrawer = false;
            })
            .catch((e) => {
              console.error(e);
              this.$message.error(
                this.$t("confirmation.solveTheConflictError")
              );
            })
            .finally(() => (this.loadingAddBtn = false));
        }
      });
    },
    onCheck(checkedSubKeys, secondArg) {
      // Tree may pass (keys, e) or (e, keys); keys may be array or { checked, halfChecked }
      const raw = Array.isArray(checkedSubKeys) ? checkedSubKeys : (Array.isArray(secondArg) ? secondArg : checkedSubKeys);
      const arr = Array.isArray(raw) ? raw : (raw && raw.checked) || [];
      this.checkedSubKeys = arr;
      this.lastCheckedSubKeys = arr;
    },
    onAppCheck(checkedAppKeys, secondArg) {
      const raw = Array.isArray(checkedAppKeys) ? checkedAppKeys : (Array.isArray(secondArg) ? secondArg : checkedAppKeys);
      const arr = Array.isArray(raw) ? raw : (raw && raw.checked) || [];
      this.checkedAppKeys = arr;
      this.lastCheckedAppKeys = arr;
    },

    isSubjectChecked(subjectId) {
      const id = subjectId != null ? String(subjectId) : subjectId;
      return this.checkedSubKeys.some((k) => String(k) === id);
    },
    toggleSubject(subjectId, checked) {
      const id = subjectId != null ? String(subjectId) : subjectId;
      if (checked) {
        if (!this.checkedSubKeys.some((k) => String(k) === id)) {
          this.checkedSubKeys = [...this.checkedSubKeys, id];
          this.lastCheckedSubKeys = [...this.lastCheckedSubKeys, id];
        }
      } else {
        this.checkedSubKeys = this.checkedSubKeys.filter((k) => String(k) !== id);
        this.lastCheckedSubKeys = this.lastCheckedSubKeys.filter((k) => String(k) !== id);
      }
    },

    allNodeIsDisabled(m) {
      if (this.conflictModuleIds[m._id]) {
        if (m.sousModules) {
          let sousModuleConflictLength = 0;
          m.sousModules.forEach((s) => {
            if (this.conflictSubModuleIds[s._id]) {
              sousModuleConflictLength += 1;
            }
          });
          return sousModuleConflictLength == m.sousModules.length;
        }
      }
      return false;
    },
    isModuleCheckable(module) {
      // College: parent not checkable when it has subjects (subjects are checkable)
      if (module.type === "college" && module.subjects && module.subjects.length > 0) {
        return false;
      }
      // Primary: parent not checkable when it has sous-modules (sous-modules are checkable)
      return !(module.sousModules && module.sousModules.length > 0);
    },
    async revokeSubjectAccess(subjectId) {
      try {
        this.$confirm({
          title: this.$t("confirmation.revokeAccess"),
          content: "",
          okText: this.$t("all.oui"),
          cancelText: this.$t("all.non"),
          onOk: async () => {
            await apiClient.post("/teacherAccess/revoke", {
              query: {
                teacher: this.selectedTeacher,
                classroom: this.selectedClassroom,
                trimester: this.selectedTrimester,
                subjectId,
              },
            });
            this.$message.success(this.$t("success.accessRevoked"));
            this.handleClassChange(this.selectedClassroom);
          },
          onCancel() {},
        });
      } catch (error) {
        console.error(error);
        this.$message.error(this.$t("error.revokeAccess"));
      }
    },
    async revokeAccess(moduleId, isSubModule = false, subModuleId = null) {
      try {
        // Show confirmation dialog before revoking access
        this.$confirm({
          title: this.$t("confirmation.revokeAccess"),
          content: "",
          okText: this.$t("all.oui"),
          cancelText: this.$t("all.non"),
          onOk: async () => {
            // Call the API to revoke access
            await apiClient.post("/teacherAccess/revoke", {
              query: {
                teacher: this.selectedTeacher, // The currently selected teacher
                classroom: this.selectedClassroom,
                trimester: this.selectedTrimester,
                moduleId,
                isSubModule,
                subModuleId: isSubModule ? subModuleId : null,
              },
            });

            // Show a success message
            this.$message.success(this.$t("success.accessRevoked"));

            // Reload the data to reflect changes
            this.handleClassChange(this.selectedClassroom);
          },
          onCancel() {},
        });
      } catch (error) {
        console.error(error);
        this.$message.error(this.$t("error.revokeAccess"));
      }
    },
    showRevocationNotification(revokedFrom) {
      const teacherNames = revokedFrom.map((r) => r.teacherName).join(", ");
      const allModuleIds = new Set();
      revokedFrom.forEach((conflict) => {
        conflict.modules.forEach((mod) => {
          allModuleIds.add(mod.moduleId);
        });
      });

      const moduleNames = Array.from(allModuleIds)
        .map((moduleId) => this.getModuleNameById(moduleId))
        .join(", ");

      const message = `${this.$t("enseignant.revokedAccessFrom")} ${teacherNames} ${this.$t("enseignant.onModules")} ${moduleNames}`;

      this.$message.warning(message, 8);
    },
    getModuleNameById(moduleId) {
      const module = this.appTreeData.find((m) => m._id === moduleId);
      return module ? module.name : this.$t("enseignant.unknownModule");
    },
  },
};
</script>
<style>
[data-kit-theme="default"] .stat-card .ant-card-body {
  padding: 10px !important;
  background: #eee;
  border-radius: 2px;
}
</style>
